import { Button, Col, Modal, Row, message, DatePicker } from "antd";
import { Form, Formik } from "formik";
import SelectInput from "./inputs/SelectInput";
import { deliveryStatus, roles } from "../constants/others";
import * as Yup from 'yup';
import { postData } from "../helpers/api";
import moment from 'moment';
import DateInput from "./inputs/DateInput";
import { useMemo } from "react";

const ExportExcel = (props) => {
    const { products, isModalOpen, handleCancel, users } = props;
    const deliveryStatusValues = useMemo(() => deliveryStatus.map((el) => ({ value: el, label: el })), [])

    const handleExport = async (values, { setSubmitting }) => {
        try {
            // Create a copy of the values object for manipulation
            const exportData = { ...values };

            // Format the dates if they exist
            if (exportData.startDate) {
                exportData.startDate = moment(exportData.startDate).format('YYYY-MM-DD');
            }
            if (exportData.endDate) {
                exportData.endDate = moment(exportData.endDate).format('YYYY-MM-DD');
            }

            // Filter out null or undefined values
            const filters = Object.entries(exportData).reduce((acc, [key, value]) => {
                if (value) {
                    acc[key] = value;
                }
                return acc;
            }, {});

            // Use postData from api.js but with a custom axios configuration
            // to handle the blob response for file download
            const response = await postData('/orders/export', filters, {
                responseType: 'blob'
            });

            // Create a blob with the correct MIME type for Excel
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);

            // Create a temporary link element to trigger download
            const link = document.createElement('a');
            link.href = url;

            // Extract filename from content-disposition header or use default
            const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition
                ? contentDisposition.split('filename=')[1].replace(/"/g, '')
                : `orders_export_${new Date().toISOString().slice(0, 10)}.xlsx`;

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            message.success('File downloaded successfully');
            handleCancel(); // Close modal after successful download
        } catch (error) {
            console.error('Error downloading file:', error);
            message.error('Failed to download file. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            footer={null}
            title={"Export Excel"}
            open={isModalOpen}
            onCancel={handleCancel}
            width={500}
        >
            <Formik
                initialValues={{
                    userId: null,
                    role: null,
                    productId: null,
                    startDate: null,
                    endDate: null,
                    deliveryStatus: null
                }}
                validationSchema={
                    Yup.object({
                        userId: Yup.string().nullable().optional(),
                        productId: Yup.string().nullable().optional(),
                        role: Yup.string().nullable().optional(),
                        startDate: Yup.date().nullable().optional(),
                        endDate: Yup.date().nullable().optional(),
                        deliveryStatus: Yup.string().nullable().optional()
                    })
                }
                onSubmit={handleExport}
            >
                {({ isSubmitting, handleSubmit, setFieldValue, values }) => (
                    <Form onSubmit={handleSubmit}>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <SelectInput
                                    name="userId"
                                    placeholder={"Subordonnés"}
                                    options={users}
                                />
                            </Col>
                            <Col span={24}>
                                <SelectInput
                                    name="role"
                                    size="large"
                                    placeholder="Role"
                                    options={roles.map(role => ({
                                        value: role,
                                        label: role
                                    }))}
                                />
                            </Col>
                            <Col span={24}>
                                <SelectInput
                                    name="productId"
                                    placeholder={"Produit"}
                                    options={products}
                                />
                            </Col>
                            <Col span={24}>
                                <DateInput
                                    name="startDate"
                                    placeholder="Date début de la commande"
                                />
                            </Col>
                            <Col span={24}>
                                <DateInput
                                    name="endDate"
                                    placeholder="Date fin de la commande"
                                />
                            </Col>
                            <Col span={24}>
                                <SelectInput
                                    name="deliveryStatus"
                                    placeholder={"Livraison"}
                                    options={deliveryStatusValues}
                                />
                            </Col>
                            <Col span={24}>
                                <Button
                                    size='large'
                                    type="primary"
                                    htmlType="submit"
                                    loading={isSubmitting}
                                    style={{ width: "100%" }}
                                >
                                    Export
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
}

export default ExportExcel;